import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';

import '../../index.css';
import Pagination from '../../components/Pagination';
import checkedIcon from '../../icons/ic-checked.png';
import checkedOrangeIcon from '../../icons/ic-checked-orange.png';
import uncheckedIcon from '../../icons/ic-unchecked.png';
import closeIcon from '../../icons/ic-close.png';
import searchIcon from '../../icons/ic-search.png';
import wizmonIcon from '../../icons/ic-wizmon.png';

const StatisticsSelectItemModal = ({
  close,
  save,
  header,
  itemList,
  onSelectItem,
  onSelectAllItem,
  selectedItemList,
  itemType,
  shopMode,
  makeshopURL
}) => {

  const itemKey = shopMode === 'cafe24' ? (itemType === 'product' ? 'itemNo' : 'contentsNo') : 'uid' ;
  const itemImg = shopMode === 'cafe24' ? (itemType === 'product' ? 'itemImage' : 'thumbnail') : 'maximage';
  const itemName = shopMode === 'cafe24' ? (itemType === 'product' ? 'name' : 'title') : 'product_name';

  const [searchResult, setSearchResult] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [allSelected, setAllSelected] = useState(false);

  const [itemsPerPage, setItemPerPage] = useState(8);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [currentPage, setCurrentPage] = useState(1);

  const inputRef = useRef(null);

  const searchContainerStyle = {
    position: 'relative',
    width: '100%', // 필요한 경우 조정
  };

  // 검색 버튼 스타일
  const searchButtonStyle = {
    position: 'absolute',
    right: '20px',
    top: '55%', // 버튼을 수직으로 가운데 정렬
    transform: 'translateY(-50%)', // 버튼을 수직으로 가운데 정렬
    border: 'none', // 필요한 경우 추가 스타일
    background: 'none',
    cursor: 'pointer',
  };

  const selectedItemNoList = selectedItemList.map((item) => {
    console.log(item)
    console.log(itemKey)
    return item[itemKey];
  });

  useEffect(() => {
    if (selectedItemList.length === itemList.length) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  }, [selectedItemList, itemList]);

  const closeModal = () => {
    setSearchResult([]);
    setCurrentPage(1);
    setIsSearch(false);
    close();
  };

  const searchContent = () => {
    if (inputRef.current.value !== '') {
      const search = inputRef.current.value;
      const regex = new RegExp(search, 'gi');
      const result = itemList.filter((item) => {
        return regex.test(item[itemName]) || item[itemName].includes(search);
      });

      setSearchResult(result);
      setIsSearch(true);
      setCurrentPage(1);
    } else {
      alert('검색어를 입력하세요.');
    }
  };

  const onKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (e.target.value !== '') {
        searchContent();
      } else {
        alert('검색어를 입력하세요.');
      }
    }
  };

  const onChange = (e) => {
    e.preventDefault();
    if (e.target.value === '') {
      setIsSearch(false);
      setCurrentPage(1);
    }
  };

  const selectItemHandler = (itemNo) => {
    onSelectItem(itemNo);
  };

  const checkAll = (e) => {
    setAllSelected((prev) => !prev);
    onSelectAllItem();
  };

  const contents = (isSearch ? searchResult : itemList).map((item, idx) => {
    let start = (currentPage - 1) * itemsPerPage;



    if (start <= idx && idx < start + itemsPerPage) {
      return (
        <div
          onClick={() => {
            selectItemHandler(item[itemKey]);
          }}
          key={item[itemKey]}
          style={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            width: '50%',
            height: '25%',
            marginBottom: '20px',
            paddingLeft: itemType === 'product' ? '80px' : '20px',
            justifyContent: 'flex-start',
          }}
        >
          <img
            alt="선택 아이콘"
            style={{
              display: 'inline-block',
              width: '40px',
              filter: selectedItemNoList.includes(item[itemKey])
                ? 'none'
                : 'invert(100%)',
              opacity: selectedItemNoList.includes(item[itemKey]) ? '1' : '0.1',
            }}
            src={
              selectedItemNoList.includes(item[itemKey])
                ? checkedIcon
                : uncheckedIcon
            }
          />
          <div className="container">
            <div className="content">
              <img
                style={{
                  marginLeft: '10px',
                  display: 'inline-block',
                  width: itemType === 'product' ? '100px' : '250px',
                  height: itemType === 'product' ? '100px' : '150px',
                  border: itemType === 'product' ? '0.3px solid' : '2px solid',
                  borderColor: itemType === 'product' ? '#000' : '#ccc',
                  borderRadius: itemType === 'product' ? '3px' : '5px',
                }}
                src={shopMode === 'cafe24' ? (item[itemImg] !== null ? item[itemImg] : wizmonIcon) : makeshopURL + item[itemImg]}
                alt={(itemType === 'product' ? '상품' : '유튜브') + '이미지'}
              ></img>
              <div className="contentInfo" style={{ marginLeft: '10px' }}>
                <p
                  style={{
                    wordWrap: 'normal',
                    marginLeft: '22px',
                    marginBottom: '20px',
                    fontSize: '20px',
                  }}
                >
                  {item[itemName]}
                </p>
                <p
                  style={{
                    marginLeft: '22px',
                    fontSize: '20px',
                  }}
                >
                  {moment(item.createDate).format('YYYY년 MM월 DD일')}
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    }
  });

  return (
    <div className="openModal s_select_modal">
      <section style={{ borderRadius: 10 }}>
        <button
          onClick={closeModal}
          style={{
            position: 'absolute',
            padding: '24px 27px 0px 0px',
            zIndex: '1',
            border: 'none',
            background: 'none',
            right: 30,
          }}
        >
          <img
            src={closeIcon}
            alt="닫기"
            style={{ width: '32px', height: '32px' }}
          />
        </button>
        <header
          style={{
            padding: '66px 60px 16px 60px',
            font: 30,
            fontWeight: 400,
            borderRadius: 10,
          }}
        >
          {header}
        </header>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            flexDirection: 'column',
            padding: '0px 60px',
            width: '100%',
          }}
        >
          <div
            style={{
              padding: '0px 60px',
              width: '100%',
              height: 1,
              backgroundColor: '#848484',
            }}
          />
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '18px 50px 0px 50px',
            }}
          >
            <div style={searchContainerStyle}>
              <input
                style={{
                  width: '100%',
                  height: '52px',
                  borderRadius: '5px',
                  border: '1px solid #E5E5E5',
                  padding: '0px 20px',
                  fontSize: '20px',
                  backgroundColor: '#fafafa',
                }}
                ref={inputRef}
                className="search"
                placeholder="검색어를 입력해주세요."
                onChange={onChange}
                onKeyPress={onKeyPress}
              />
              <button
                style={searchButtonStyle}
                className="searchBtn"
                onClick={searchContent}
              >
                <img src={searchIcon} alt="search" className="searchImg" />
              </button>
            </div>

            <div
              onClick={checkAll}
              className="select_all"
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                padding: '12px 0px',
                cursor: 'pointer',
                alignItems: 'center',
              }}
            >
              <img
                style={{
                  display: 'inline-block',
                  width: '25px',
                  cursor: 'pointer',
                  filter: allSelected ? 'none' : 'invert(100%)',
                  opacity: allSelected ? 1 : 0.1,
                }}
                src={allSelected ? checkedOrangeIcon : uncheckedIcon}
                alt="전체 선택"
              />
              <p>전체 선택</p>
            </div>
          </div>
        </div>
        <main
          style={{
            padding: '12px 0px',
            width: '90%',
            margin: '0 auto',
          }}
        >
          {itemList.length !== 0 ? contents : '불러오는 중...'}
        </main>
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={isSearch ? searchResult.length : itemList.length}
          paginate={setCurrentPage}
          currentPage={currentPage}
          pageCount={10}
        />
        <footer>
          <button onClick={save}>저장</button>
        </footer>
      </section>
    </div>
  );
};

export default StatisticsSelectItemModal;
